import BaseAPI from '../base'

function checkQid(qId) {
    return BaseAPI.sendGet(`queue/check_qid`, {
        qId
    });
}

function getList() {
    return BaseAPI.sendGet(`queue/list`);
}

function getCafe() {
    return BaseAPI.sendGet(`queue/cafe`);
}

function getMenu() {
    return BaseAPI.sendGet(`queue/menu`);
}

function getMenus() {
    return BaseAPI.sendGet(`queue/menus`);
}

function cancelOrder(order_id, reason) {
    return BaseAPI.sendPost(`queue/cancel`, {
        order_id,
        reason
    });
}

function acceptOrder(order_id, list, reason, waiting_time) {
    return BaseAPI.sendPost(`queue/accept`, {
        order_id,
        list,
        reason,
        waiting_time
    });
}

function serveOrder(order_id) {
    return BaseAPI.sendPost(`queue/serve`, {
        order_id
    });
}

function editOrder(order_id, list, appends) {
    return BaseAPI.sendPost(`queue/edit`, {
        order_id,
        list,
        appends
    });
}

function payOrder(order_id) {
    return BaseAPI.sendPost(`queue/pay`, {
        order_id
    });
}

function closeOrder(order_id, pay_method, discount) {
    return BaseAPI.sendPost(`queue/close`, {
        order_id,
        pay_method,
        discount
    });
}

function acceptAppend(order_id, append_index, list) {
    return BaseAPI.sendPost(`queue/append/accept`, {
        order_id,
        append_index,
        list
    });
}

function cancelAppend(order_id, append_index, reason) {
    return BaseAPI.sendPost(`queue/append/cancel`, {
        order_id,
        append_index,
        reason
    });
}

function mergeOrders(primary_order, secondary_orders) {
    return BaseAPI.sendPost(`queue/merge`, {
        primary_order,
        secondary_orders
    });
}

function splitOrders(order_id, list) {
    return BaseAPI.sendPost(`queue/split`, {
        order_id,
        list
    });
}

function moveOrder(order_id, section, table) {
    return BaseAPI.sendPost(`queue/move`, {
        order_id,
        section,
        table
    });
}

function moveOrders(orders, section, table) {
    return BaseAPI.sendPost(`queue/moveMany`, {
        orders,
        section,
        table
    });
}

function createOrder(cart, section, table) {
    return BaseAPI.sendPost(`queue/create`, {
        cart,
        section,
        table
    });
}

function queryArchive(start, end, mode, pay_method) {
    return BaseAPI.sendGet(`queue/archive`, {
        start,
        end,
        mode,
        pay_method,
        schema: 'new'
    });
}

function returnOrder(order_id) {
    return BaseAPI.sendPost(`queue/return`, {
        order_id,
    });
}

function getJoinedTables() {
    return BaseAPI.sendGet(`queue/joinedTables`);
}

function syncJoinedTables(joined_tables) {
    return BaseAPI.sendPost(`queue/syncJoinedTables`, {
        joined_tables
    });
}

function getReserveList() {
    return BaseAPI.sendGet(`queue/reserve/list`);
}

function cancelReservation(id, reason) {
    return BaseAPI.sendPost(`queue/reserve/cancel`, {
        reservation_id: id,
        reason
    });
}

function acceptReservation(id) {
    return BaseAPI.sendPost(`queue/reserve/accept`, {
        reservation_id: id
    });
}

function getNotifications() {
    return BaseAPI.sendGet(`queue/notifications`);
}

function markNotificationsRead() {
    return BaseAPI.sendPost(`queue/notifications/read`);
}

function searchClient(phone) {
    return BaseAPI.sendGet(`queue/search_client`, {
        phone
    });
}

function createReservation(data) {
    return BaseAPI.sendPost(`queue/create_reserve`, data);
}

function editPreorder(id, list)  {
    return BaseAPI.sendPost(`queue/preorder/edit`, {
        preorder_id: id,
        list
    });
}

export default {
    checkQid,
    getList,
    getCafe,
    getMenu,
    cancelOrder,
    acceptOrder,
    serveOrder,
    payOrder,
    closeOrder,
    editOrder,
    acceptAppend,
    cancelAppend,
    mergeOrders,
    splitOrders,
    moveOrder,
    createOrder,
    queryArchive,
    returnOrder,
    moveOrders,
    getJoinedTables,
    syncJoinedTables,
    getReserveList,
    cancelReservation,
    acceptReservation,
    getNotifications,
    markNotificationsRead,
    searchClient,
    createReservation,
    editPreorder,
    getMenus
}